import { render, staticRenderFns } from "./ObjectCode.vue?vue&type=template&id=73812d9a&"
import script from "./ObjectCode.vue?vue&type=script&lang=js&"
export * from "./ObjectCode.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports